<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  created () {
    this.$store.dispatch('get_active_exchanges')
    if (localStorage.getItem('currency') === null) {
      this.$store.state.CurrencyStore.browser_currency = 'KES'
      localStorage.setItem('currency', 'KES')
    }
    this.$store.commit('LOCAL_CURRENCY2', { currency_name: 'KES', currency_public_id: '162fface-f5f1-41de-913b-d2bb784dda3a' })
  }
}
</script>
<style>
  .pantone {
    background-color: #73a533;
    color: white;
  }
  .musk {
    background-color: #520036;
    color: white;
  }
</style>
